import React from 'react';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { FilledSquareIcon, EmptySquareIcon } from 'global/components/PerformIcons';
import { getColorFromScore } from 'global/styles';
import useStyles from './styles';
import { useView } from 'global/hooks/useView';
import { get } from '../../lib/lodash';

// Expects props.score as a float between 0 and 1
// score values -1 are processed to black

export default (props) => {
  const { isBw, isAddMenu } = props;
  const classes = useStyles();
  const { isDark } = useView();
  if (isAddMenu) {
    if (props.score === null) {
      return <AddCircleOutlineIcon style={{ color: 'dark-grey' }} />;
    }
    return <AddCircleIcon style={{ color: 'black' }} />;
  } else if (props.score === null) {
    return <EmptySquareIcon color="disabled" style={{ paddingRight: '4px' }} />;
  } else if (props.selected) {
    return <CheckBoxIcon className={props.disabled ? classes.iconDisabled : classes.icon} onClick={props.onClick} style={{ color: isDark ? 'white' : 'black' }} />;
  } else if (props.indeterminate) {
    return <IndeterminateCheckBoxIcon className={props.disabled ? classes.iconDisabled : classes.icon} onClick={props.onClick} style={{ color: isDark ? 'white' : 'black' }} />;
  }

  const sc = typeof props.score === 'string' ? parseFloat(props.score) : props.score;
  const stroke = props.useBlankCheckbox ? (isDark ? 'white' : 'black') : 'none';
  const opacity = props.useBlankCheckbox ? '0.4' : '1';

  const hasRanges = props.scorecardConfig ? [get(props, 'scorecardConfig.minScore', 0), get(props, 'scorecardConfig.maxScore', 100)] : undefined;

  return (
    <FilledSquareIcon
      className={props.disabled ? classes.iconDisabled : classes.icon}
      onClick={props.onClick}
      style={{ color: getColorFromScore(sc, hasRanges, isBw), stroke: stroke, fillOpacity: opacity, strokeWidth: 2 }}
    />
  );
};
